import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {uuid} from '../../utilities';
import {OnChangePayload, TypeEnum} from "../../models";

@Component({
  selector: 'element-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent implements OnInit,OnChanges {

  name: string;

  values: ToggleValue[];

  constructor() {

    this.name = uuid();

    const $null: ToggleValue = {
      icon: "<span class=\"material-symbols-outlined size-2em\">close</span>",
      value: undefined,
      color: "#393939",
      bgColor: "#ffffff"
    };

    const $true: ToggleValue = {
      icon: this.options?.values[1]?.label ?? "<span class=\"material-symbols-outlined size-2em\">package_2</span>",
      label: "Pickup Complete",
      value: true,
      color: "#ffffff",
      bgColor: "#3a6946"
    };

    const $false: ToggleValue = {
      icon: this.options?.values[0]?.label ?? "<span class=\"material-symbols-outlined size-2em\">deployed_code_history</span>",
      label: "Pending Pickup",
      value: false,
      color: "#3a6946",
      bgColor: "#ffffff",
    };

    this.values = [$false, $null, $true];
  }

  @Output() change = new EventEmitter<OnChangePayload>();

  @Input() options: ToggleOptions | undefined;
  @Input() selected: boolean | undefined;

  position = 0;
  color = "#000000";
  bgColor = "#ffffff";

  ngOnChanges(changes: SimpleChanges) {
    this.setPosition();
  }

  ngOnInit() {

    //Normalize inputted selected value to boolean.
    if (typeof this.selected == "string") {
      this.selected = (this.selected != "undefined") ? (this.selected == "true") ? true : false : undefined;
    }

    this.setPosition();
  }

  getLabel() {
    return this.values.find(i => i.value == this.selected && i.value != undefined)?.label ?? "";
  }

  setSelected(value?: boolean) {
    this.selected = value;

    this.setPosition();

    this.change.emit({
      type: TypeEnum.Toggle,
      id: 'shipped',
      payload: value
    });

  }

  setPosition() {
    const idx = this.values.findIndex(i => i.value == this.selected);
    if (idx >= 0) {
      this.position = 35 * idx;
      this.bgColor = this.values[idx]?.bgColor ?? "#ffffff";
      this.color = this.values[idx]?.color ?? "#000000";
    }
  }


}

export interface ToggleEvent {
  value?: boolean;
}

export interface ToggleOptions {
  values: (ToggleValue | undefined)[];
}

export interface ToggleValue {
  icon?: string;
  label?: string;
  value?: boolean;
  color?: string;
  bgColor?: string;
}

